import Vue from 'vue'
import { shouldPolyfill } from '@formatjs/intl-relativetimeformat/should-polyfill'
import { shouldPolyfill as shouldPolyfillIntlLocale } from '@formatjs/intl-locale/should-polyfill'
import PortalVue from 'portal-vue'
import API from './services/API'
import * as Sentry from '@sentry/browser'
import { Vue as VueIntegration } from '@sentry/integrations'
import { Integrations } from '@sentry/tracing'
import VueNotification from 'vue-notification'
import VTooltip from 'v-tooltip'
import VModal from 'vue-js-modal'
// @ts-ignore
import VueCroppie from 'vue-croppie'
import App from './App.vue'
import router from './router'
import store from './store/store'
import Translator from './plugins/Translator'
import Routing from './plugins/Routing'
import VueBreakpoints from './plugins/Breakpoints'
// @ts-ignore
import AirbnbDatepicker from 'vue-airbnb-style-datepicker'
import VueIsMobile from './plugins/vue-is-mobile'
// @ts-ignore
import VueCarousel from 'vue-carousel'

// @ts-ignore
import $ from '../node_modules/jquery'
import '../node_modules/popper.js'
import '../node_modules/bootstrap'
import '@lottiefiles/lottie-player'

import './assets/scss/app.scss'
import './assets/styles/spa.scss'
import './assets/styles/vue-croppie.scss'
import './assets/icons/ionicons/scss/ionicons.scss'
import './assets/styles/FF-icon.css'
import '../node_modules/ionicons/dist/css/ionicons.css'
import '../node_modules/ionicons/dist/ionicons.js'
import '../node_modules/vue-airbnb-style-datepicker/dist/vue-airbnb-style-datepicker.min.css'
import '../node_modules/vue-multiselect/dist/vue-multiselect.min.css'
import '../node_modules/animate.css/animate.css'
import '../node_modules/font-awesome/css/font-awesome.css'

// import '@shoelace-style/shoelace/dist/shoelace/shoelace.css'
// import {SlButton, SlDrawer, SlDropdown, SlMenu, SlMenuItem} from '@shoelace-style/shoelace';
import visibility from 'vue-visibility-change'
import Nl2br from './plugins/Nl2br'
import TwitterFeed from 'vuejs-twitter-feed'
import importFacebookSdk from '@/utils/importFacebookSdk'
import { initHotjar } from '../vendors/hotjar/setup.js'
import { loadChargebeeScript } from '@/../vendors/chargebee/init-chargebee'
import vueIsMondrian from './plugins/vue-is-mondrian'

Vue.config.productionTip = true
Vue.config.devtools = true
Vue.config.ignoredElements = ['x-trans', 'ion-icon', /^sl-/]

window.feather = require('feather-icons')

// @ts-ignore
require(`./assets/styles/themes/mondrian.scss`)


// @ts-ignore
window.$ = window.jQuery = $

// @ts-ignore
window.Routing = Routing

Vue.use(TwitterFeed)
Vue.use(VueNotification)
Vue.use(PortalVue)
Vue.use(VueCarousel)
VTooltip.enabled = window.innerWidth > 768
Vue.use(VTooltip)
Vue.use(VueIsMobile, {
    breakpoint: 700,
})
Vue.use(Translator)
Vue.use(Nl2br)
Vue.use(VueCroppie)
Vue.use(VModal)
Vue.use(visibility)
Vue.use(vueIsMondrian)
Vue.use(VueBreakpoints, {
    debug: true,
    breakpointRanges: {
        xs: [0, 575],
        sm: [576, 767],
        md: [768, 991],
        lg: [992, 1199],
        xl: [1200, 9999999],
    },
})
Vue.use(AirbnbDatepicker, {
    colors: {
        selected: 'var(--mixed-color)',
        inRange: 'rgba(var(--mixed-color-rgb), .7)',
        inRangeBorder: 'rgba(var(--mixed-color-rgb), .7)',
        hoveredInRange: 'rgba(var(--mixed-color-rgb), .85)',
    },
})

/* Polyfill to support Intl.RelativeTimeFormat on older iOS devices (https://caniuse.com/?search=Intl.RelativeTimeFormat) */
if (shouldPolyfill()) {
    // Load the polyfill 1st BEFORE loading data
    import('@formatjs/intl-relativetimeformat/polyfill').then(() => {
        // @ts-ignore
        if (window.Intl.RelativeTimeFormat.polyfilled) {
            // @ts-ignore
            import('@formatjs/intl-relativetimeformat/locale-data/en')
            // @ts-ignore
            import('@formatjs/intl-relativetimeformat/locale-data/fr')
        }
    })
}

if (shouldPolyfillIntlLocale()) {
    import('@formatjs/intl-locale/polyfill')
}

// Force token en DEV
if (process.env.NODE_ENV === 'development') {
    // @ts-ignore
    // window.currentJwt = window.currentJwt || process.env.VUE_APP_DEV_TOKEN
    // @ts-ignore
    window.currentAuthSocket = window.currentAuthSocket || JSON.parse(process.env.VUE_APP_DEV_AUTH_SOCKET)

    // @ts-ignore
    window.Routing = {
        generate: (url: string) => `#mocked-${url}`,
    }

    // @ts-ignore
    if (!window.Translator) {
        // @ts-ignore
        window.Translator = {
            trans: (key: string) => key,
        }
    }

    // @ts-ignore
    if (!window.payload) {
        // @ts-ignore
        window.payload = {
            // "layout":"back-to-school-2020",
            eligible: false,
            layout: 'classic',
            flow: 'regular',
            lead: {
                eligible: false,
                id: '2aeef2ec-1427-49eb-bf4e-48e2fc6558f0',
                firstName: '',
                lastName: '',
            },
            // Expert plan
            // plan: {"id":"b97c1636-b578-4ec1-8a63-33cb46ddb759","name":"Expert Membership","price":{"amount":"1990","value":199000,"currency":"USD"}},
            // Startup plan
            // "plan": {
            //     "id":"6f02fc02-f337-4f40-a793-47341bff4ba0",
            //     "name":"Startup Membership",
            //     "price": {
            //         "amount": "590",
            //         "value": 59000,
            //         "currency": "USD"
            //     }
            // },
            // Regular Plan
            plan: {
                id: 'f7414897-4388-4a11-9bb0-40be57bd70a4',
                name: 'Regular Membership',
                price: {
                    amount: '990',
                    value: 99000,
                    currency: 'USD',
                },
            },
            coupon: null,
            // invitation: {"godFather":{"idFF":"FF-0153141813","firstName":"Pauline","lastName":"Garnier","picture":"/uploads/members/FF-0153141813/cropped/5d8e304f879bc.jpeg"}}
        }
    }

    // @ts-ignore
    API._setBearer(window.currentJwt || process.env.VUE_APP_DEV_TOKEN)

    const ekkoConfig = {
        appId: '3836d6c5-d107-49ce-9bb1-a41a03488124',
        server: 'chat-eu-1.ekko.chat',
        userId: 'FF-9252764141',
        userToken: 'a551cb7d-5954-4b3f-8ac4-730f7e96379d',
        messaging: 'ekko',
        userRole: 'admin',
    }
    // @ts-ignore
    window.ekkoConfig = ekkoConfig
} else if (process.env.VUE_APP_SENTRY_DSN) {
    Sentry.init({
        dsn: process.env.VUE_APP_SENTRY_DSN,
        integrations: [
            new VueIntegration({ Vue, attachProps: true, tracing: true }),
            new Integrations.BrowserTracing(),
        ],
    })
}

if (!window.customElements) {
    require('@webcomponents/custom-elements')
}

// Setting up shoelace
// customElements.define('sl-button', SlButton)
// customElements.define('sl-dropdown', SlDropdown)
// customElements.define('sl-drawer', SlDrawer)
// customElements.define('sl-menu', SlMenu)
// customElements.define('sl-menu-item', SlMenuItem)

new Vue({
    router,
    store,
    render: h => h(App),
    created() {
        importFacebookSdk()
        if (process.env.VUE_APP_HOTJAR) {
            initHotjar(process.env.VUE_APP_HOTJAR)
        }
        loadChargebeeScript()
    },
}).$mount('#app')
